import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import ReactNotification from "react-notifications-component";
import {
  Landing,
  Library,
  Profile,
  ProfileEdit,
  Login,
  Register,
  RegisterVerification,
  Forget,
  ForgetVerification,
  Reset,
  Service,
  ServiceDetail,
  ServiceSingle,
  DetailProfile,
  LawerComments,
  Book,
  CallBackConsultin,
  ConsultingList,
  CalendarLawyer,
  EditVerification,
  ServiceListComplete,
  ServiceListPending,
  Documents,
  Document,
  Transaction,
  ProfileLawyer,
  Shop,
  Cart,
  UserVerification,
  Product,
  ProductList,
  CallbackDocument,
  CallbackProduct,
  ProductOrder,
} from "../pages/index";
import { Share } from "../components/index";
import { GetTokenWithExpiry } from "../utilities/tokenSetting";

// import DataPicker from '../components/data/calendr'
const Routes = () => {
  return (
    <>
      {Boolean(GetTokenWithExpiry("token")) ? (
        <Switch>
          <Route path='/' exact>
            <ReactNotification />
            <Landing />
          </Route>
          <Route path='/library' exact>
            <Library />
          </Route>
          <Route path='/book/:id' exact>
            <Share />
            <ReactNotification />
            <Book />
          </Route>
          <Route path='/profile' exact>
            <Profile />
          </Route>
          <Route path='/profile/edit' exact>
            <ReactNotification />
            <ProfileEdit />
          </Route>
          <Route path='/profile/consultings' exact>
            <ConsultingList />
          </Route>
          <Route path='/services/complete' exact>
            <ServiceListComplete />
          </Route>
          <Route path='/services/pending' exact>
            <ServiceListPending />
          </Route>
          <Route path='/profile/documents' exact>
            <Documents />
          </Route>
          <Route path='/document/transaction' exact>
            <Transaction />
          </Route>
          <Route path='/document/:id' exact>
            <Share />
            <Document />
          </Route>
          <Route path='/shop' exact>
            <Shop />
          </Route>
          <Route path='/product/:id' exact>
            <Share />
            <ReactNotification />
            <Product />
          </Route>
          <Route path='/product-list' exact>
            <ReactNotification />
            <ProductList />
          </Route>
          <Route path='/product-list/:id' exact>
            <ReactNotification />
            <ProductOrder />
          </Route>
          <Route path='/cart' exact>
            <ReactNotification />
            <Cart />
          </Route>
          <Route path='/service' exact>
            <Service />
          </Route>
          <Route path='/service/:slug' exact>
            <ServiceDetail />
          </Route>
          <Route path='/single-service/:slug' exact>
            <ServiceSingle />
          </Route>
          <Route path='/detail-lawyer/:id' exact>
            <Share />
            <ReactNotification />
            <DetailProfile />
          </Route>
          <Route path='/profile-lawyer/:id' exact>
            <Share />
            <ReactNotification />
            <ProfileLawyer />
          </Route>
          <Route path='/calendar/:id' exact>
            <Share />
            <ReactNotification />
            <CalendarLawyer />
          </Route>
          <Route path='/comments/:id' exact>
            <LawerComments />
          </Route>
          <Route path='/callbackConsulting' exact>
            <CallBackConsultin />
          </Route>
          <Route path='/callbackDocument' exact>
            <CallbackDocument />
          </Route>
          <Route path='/callbackShop' exact>
            <CallbackProduct />
          </Route>
          <Redirect to='/' />
        </Switch>
      ) : (
        <Switch>
          <Route path='/login' exact>
            <ReactNotification />
            <Login />
          </Route>
          <Route path='/register' exact>
            <ReactNotification />
            <Register />
          </Route>
          <Route path='/registerVerification' exact>
            <ReactNotification />
            <RegisterVerification />
          </Route>
          <Route path='/forget' exact>
            <ReactNotification />
            <Forget />
          </Route>
          <Route path='/editVerification' exact>
            <ReactNotification />
            <EditVerification />
          </Route>
          <Route path='/userVerification' exact>
            <ReactNotification />
            <UserVerification />
          </Route>

          <Route path='/forgetVerification' exact>
            <ReactNotification />
            <ForgetVerification />
          </Route>
          <Route path='/reset' exact>
            <ReactNotification />
            <Reset />
          </Route>
          <Redirect to='/login' />
        </Switch>
      )}
    </>
  );
};
export default Routes;
